(() => {
  if (window.BSGParallaxBanner) {
    window.BSGParallaxBanner.initializeAll();
    return;
  }

  const SELECTOR = '[data-bsg-parallax-banner]';
  const records = new Map();
  const activeBanners = new Set();
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let updateFrame = null;

  const parallaxIsEnabled = (record) => {
    if (reduceMotion.matches) return false;
    return mobileQuery.matches ? record.mobileEnabled : record.desktopEnabled;
  };

  const updateBanner = (record) => {
    if (!parallaxIsEnabled(record)) {
      record.artwork.style.setProperty('--bsg-parallax-banner-offset', '0px');
      return;
    }

    const rect = record.stage.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    const progress = Math.min(1, Math.max(0, (viewportHeight - rect.top) / (viewportHeight + rect.height)));
    const currentOffset = parseFloat(record.artwork.style.getPropertyValue('--bsg-parallax-banner-offset')) || 0;
    const imageRect = record.image.getBoundingClientRect();

    if (imageRect.height === 0) return;

    const imageTopAtRest = imageRect.top - rect.top - currentOffset;
    const startOffset = rect.height - imageTopAtRest;
    const endOffset = 0 - imageTopAtRest - imageRect.height;
    const offset = startOffset + (endOffset - startOffset) * progress;
    record.artwork.style.setProperty('--bsg-parallax-banner-offset', `${offset.toFixed(1)}px`);
  };

  const updateActiveBanners = () => {
    updateFrame = null;
    activeBanners.forEach((banner) => {
      const record = records.get(banner);
      if (!record || !banner.isConnected) {
        activeBanners.delete(banner);
        records.delete(banner);
        return;
      }
      updateBanner(record);
    });
  };

  const requestUpdate = () => {
    if (updateFrame !== null || activeBanners.size === 0) return;
    updateFrame = window.requestAnimationFrame(updateActiveBanners);
  };

  const visibilityObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) activeBanners.add(entry.target);
            else activeBanners.delete(entry.target);
          });
          requestUpdate();
        },
        { rootMargin: '100px 0px' }
      )
    : null;

  const initializeBanner = (banner) => {
    if (records.has(banner)) return;

    const stage = banner.querySelector('[data-bsg-parallax-banner-stage]');
    const artwork = banner.querySelector('[data-bsg-parallax-banner-artwork]');
    const image = artwork && artwork.querySelector('img');
    if (!stage || !artwork || !image) return;

    records.set(banner, {
      stage,
      artwork,
      image,
      desktopEnabled: banner.dataset.parallaxDesktop === 'true',
      mobileEnabled: banner.dataset.parallaxMobile === 'true'
    });

    image.addEventListener('load', requestUpdate, { passive: true });

    if (visibilityObserver) visibilityObserver.observe(banner);
    else activeBanners.add(banner);
  };

  const initializeAll = (scope = document) => {
    if (scope.matches && scope.matches(SELECTOR)) initializeBanner(scope);
    scope.querySelectorAll(SELECTOR).forEach(initializeBanner);
    requestUpdate();
  };

  window.BSGParallaxBanner = { initializeAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);

  if (typeof mobileQuery.addEventListener === 'function') {
    mobileQuery.addEventListener('change', requestUpdate);
    reduceMotion.addEventListener('change', requestUpdate);
  }
})();
